import api from './api';

const chatService = {
  // Get all conversations
  getConversations: async (params = {}) => {
    const response = await api.get('/chat/conversations', { params });
    return response.data;
  },

  // Get a specific conversation
  getConversation: async (conversationId) => {
    const response = await api.get(`/chat/conversations/${conversationId}`);
    return response.data;
  },

  // Create a new conversation
  createConversation: async (data) => {
    const response = await api.post('/chat/conversations', data);
    return response.data;
  },

  // Update conversation
  updateConversation: async (conversationId, data) => {
    const response = await api.put(`/chat/conversations/${conversationId}`, data);
    return response.data;
  },

  // Delete conversation
  deleteConversation: async (conversationId) => {
    const response = await api.delete(`/chat/conversations/${conversationId}`);
    return response.data;
  },

  // Get messages in a conversation
  getMessages: async (conversationId, params = {}) => {
    const response = await api.get(`/chat/conversations/${conversationId}/messages`, { params });
    return response.data;
  },

  // Add participants to conversation
  addParticipants: async (conversationId, data) => {
    const response = await api.post(`/chat/conversations/${conversationId}/participants`, data);
    return response.data;
  },

  // Remove participant from conversation
  removeParticipant: async (conversationId, participantId) => {
    const response = await api.delete(`/chat/conversations/${conversationId}/participants/${participantId}`);
    return response.data;
  }
};

export default chatService;


